import { InputShippingAddress, NotesInfo } from '../types/interfaces';
import { splitStringWithoutBreakingWords } from './commonUtils';

export const extractNotesInfo = (inputString: string) => {
  const notesInfo: NotesInfo = { breedDate: '', dryVaporShipperTank: '', remainingText: '' };

  const regexPatterns = {
    breedDate: /Breed Date:\s*(\d{1,2}\/\d{1,2}\/\d{4})/,
    dryVaporShipperTank: /Rent a dry vapor shipper tank from RSG for shipping order:\s*(Yes|No)/,
    pickupInfo: /Pickup Information:\s*Name:\s*([\w\s]+)\s*Phone:\s*([\d\s+-]+)\s*Pickup Date:\s*(\d{1,2}\/\d{1,2}\/\d{4})/,
    shippingAddress:
      /Shipping Address\s+Address 1:\s*(.*?)\s*Address 2:\s*(.*?)\s*City:\s*(.*?)\s*State:\s*(.*?)\s*Zip Code:\s*([\d\s-]+)\s*Country:\s*(.*)/,
  };

  const matches = {
    breedDateMatch: inputString.match(regexPatterns.breedDate),
    dryVaporShipperTankMatch: inputString.match(regexPatterns.dryVaporShipperTank),
    pickupInfoMatch: inputString.match(regexPatterns.pickupInfo),
    shippingAddressMatch: inputString.match(regexPatterns.shippingAddress),
  };

  if (matches.breedDateMatch) {
    notesInfo.breedDate = matches.breedDateMatch[1];
  }

  if (matches.dryVaporShipperTankMatch) {
    notesInfo.dryVaporShipperTank = matches.dryVaporShipperTankMatch[0];
  }

  if (matches.pickupInfoMatch) {
    notesInfo.pickupInfo = {
      name: matches.pickupInfoMatch[1].replace(/\n+/g, '').trim(),
      phone: matches.pickupInfoMatch[2].replace(/\n+/g, '').trim(),
      pickupDate: matches.pickupInfoMatch[3],
    };
  }

  if (matches.shippingAddressMatch) {
    notesInfo.shippingAddress = {
      address1: matches.shippingAddressMatch[1],
      address2: matches.shippingAddressMatch[2],
      city: matches.shippingAddressMatch[3],
      state: matches.shippingAddressMatch[4],
      zipCode: matches.shippingAddressMatch[5].replace(/\n+/g, '').trim(),
      country: matches.shippingAddressMatch[6],
    };
  }

  let remainingText = inputString;
  for (const match of Object.values(matches)) {
    if (match) remainingText = remainingText.replace(match[0], '');
  }

  notesInfo.remainingText = remainingText.replace(/\n+/g, ' ').trim();
  return notesInfo;
};

export const getShippingInfo = (shippingInfo: InputShippingAddress) => {
  const address1 = splitStringWithoutBreakingWords(shippingInfo.address1, 40);
  const address2 = splitStringWithoutBreakingWords(shippingInfo.address2, 55);
  const cityStateZipCountryString = `${shippingInfo.city}, ${shippingInfo.state} ${shippingInfo.zipCode}, ${shippingInfo.country}`;
  const location = splitStringWithoutBreakingWords(cityStateZipCountryString, 60);

  return [...address1, ...address2, ...location];
};
